import { render } from "./DesktopBrandCorner.vue?vue&type=template&id=2d413205&scoped=true"
import script from "./DesktopBrandCorner.vue?vue&type=script&lang=js"
export * from "./DesktopBrandCorner.vue?vue&type=script&lang=js"

import "./DesktopBrandCorner.vue?vue&type=style&index=0&id=2d413205&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d413205"]])

export default __exports__